import React from 'react'
import { IconSearch } from './ArIcons'

const SEVERITY = [
  { key: 'all', label: 'ALL' },
  { key: '30', label: '30+' },
  { key: '60', label: '60+' },
  { key: '90', label: '90+' }
]

// Filter bar: severity segmented control, search, min past due, last-payment /
// last-activity selects, and a Paused-only toggle chip.
const ArFilterBar = ({ filters, onChange, paymentFilterEnabled }) => {
  const set = (patch) => onChange({ ...filters, ...patch })

  return (
    <div className="ar-filters">
      <div className="ar-seg">
        {SEVERITY.map(option => (
          <button
            key={option.key}
            type="button"
            className={`ar-seg-btn ${filters.severity === option.key ? 'active' : ''}`}
            onClick={() => set({ severity: option.key })}
          >{option.label}</button>
        ))}
      </div>

      <div className="ar-search">
        <span className="ar-search-icon"><IconSearch size={14} /></span>
        <input
          type="text"
          placeholder="Search company / property / invoice"
          value={filters.search}
          onChange={event => set({ search: event.target.value })}
        />
      </div>

      <input
        className="ar-input ar-input-min"
        type="number"
        min="0"
        placeholder="Min past due"
        title="Hide properties whose past-due amount is below this"
        value={filters.minBalance}
        onChange={event => set({ minBalance: event.target.value })}
      />

      <select
        className="ar-input"
        value={filters.lastPayment}
        disabled={!paymentFilterEnabled}
        title={paymentFilterEnabled ? 'Hide companies that paid more recently than this' : 'Needs DB-computed source (payment history)'}
        onChange={event => set({ lastPayment: event.target.value })}
      >
        <option value="">Last payment: any</option>
        <option value="30">No payment 30+ days</option>
        <option value="60">No payment 60+ days</option>
        <option value="never">Never paid</option>
      </select>

      <select
        className="ar-input"
        value={filters.lastActivity}
        title="Hide companies touched more recently than this"
        onChange={event => set({ lastActivity: event.target.value })}
      >
        <option value="">Last activity: any</option>
        <option value="7">Quiet 7+ days</option>
        <option value="30">Quiet 30+ days</option>
      </select>

      <button
        type="button"
        className={`ar-chip-toggle ${filters.pausedOnly ? 'active' : ''}`}
        title="Only companies with a pause request"
        onClick={() => set({ pausedOnly: !filters.pausedOnly })}
      >PAUSED ONLY</button>
    </div>
  )
}

export default ArFilterBar
